import React from 'react';
import Spinner from './Spinner';

const SpinnerRow = (props) => {
  return (
    <div className="spinner-row">
      <Spinner />
    </div>
  );
};

export default SpinnerRow;